import {
    madnes_anim_add,
    madnes_anim_add_oncomplete,
    madnes_anim_add_oncomplete_once,
    madnes_anim_loop,
    madnes_anim_play,
    madnes_anim_stop,
    madnes_anims_exists,
    madnes_anims_remove
} from "../../../framework/src/engine/madnes/madnes_anims";

/**
 * @constructor
 * @returns {MadnesAnims}
 */
export function MadnesAnims() {
    this.madnesObject = null;
};

/**
 * @param {MadnesObject} madnesObject
 * @returns {MadnesAnims}
 */
MadnesAnims.prototype.create = function(madnesObject) {
    this.madnesObject = madnesObject;
    return this;
};

/**
 * @param {string} animName
 * @param {Array=} range
 */
MadnesAnims.prototype.add = function(animName, range) {
    madnes_anim_add(this.madnesObject.name, animName, range);
    return this;
};

/**
 * @param {Function} func
 */
MadnesAnims.prototype.addOnComplete = function(func) {
    madnes_anim_add_oncomplete(this.madnesObject.name, func.bind(this.madnesObject));
    return this;
};

/**
 * @param {Function} func
 */
MadnesAnims.prototype.addOnCompleteOnce = function(func) {
    madnes_anim_add_oncomplete_once(this.madnesObject.name, func);
    return this;
};

/**
 * @param {string} animName
 * @param {number=} speed
 */
MadnesAnims.prototype.play = function(animName, speed) {
    madnes_anim_play(this.madnesObject.name, animName, speed);
};

/**
 * @param {string} animName
 * @param {number=} speed
 */
MadnesAnims.prototype.loop = function(animName, speed) {
    madnes_anim_loop(this.madnesObject.name, animName, speed);
};

MadnesAnims.prototype.stop = function() {
    madnes_anim_stop(this.madnesObject.name);
};

/**
 * @param {string} animName
 * @returns {boolean}
 */
MadnesAnims.prototype.exists = function(animName) {
    return madnes_anims_exists(this.madnesObject.name, animName);
};

MadnesAnims.prototype.destroy = function() {
    madnes_anims_remove(this.madnesObject.name);
    this.madnesObject.anims = null;
};